import { render, staticRenderFns } from "./StorageShippingUnitsConsultation.vue?vue&type=template&id=40da4fcf&"
import script from "./StorageShippingUnitsConsultation.vue?vue&type=script&lang=ts&"
export * from "./StorageShippingUnitsConsultation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports